

export default function filtrarDocumento(documentos,tipo){
    let itemsfiltrados =[];
    switch (tipo) {
        case "Recibos":
            recibo(documentos)
            break;
        case "Proformas":
            proformas(documentos)
            break;
        case "Facturas Electrónicas":
            facturasElectronicas(documentos)
            break;
        case "Envios":
            Envios(documentos)
            break;    
            
        default:
            sinFiltro(documentos)
            break;
    }

    //Funcion para filtrar por recibo
    function recibo(documentos){
        itemsfiltrados =  documentos.filter(elemento=>elemento.documento=="Recibo")
        
    }

    function proformas(documentos){
        itemsfiltrados = documentos.filter(elemento=>elemento.documento=="Proforma")
    }

    function facturasElectronicas(documentos){
        itemsfiltrados = documentos.filter(elemento=>elemento.documento=="Factura Electrónica")
    }

    function Envios(documentos){
        itemsfiltrados = documentos.filter(elemento=>elemento.documento=="Envios")
    }

    function sinFiltro(documentos){
        itemsfiltrados = documentos
    }

    return itemsfiltrados;
}